var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPsApr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    transform: "matrix(1 0 0 -1 0 40)",
    fill: "#F1ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21C17.7 21 19 22.3 19 24C19 25.7 17.7 27 16 27C14.3 27 13 25.7 13 24C13 22.3 14.3 21 16 21ZM16 25C16.6 25 17 24.6 17 24C17 23.4 16.6 23 16 23C15.4 23 15 23.4 15 24C15 24.6 15.4 25 16 25Z",
    fill: "#9C82FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19C22.3 19 21 17.7 21 16C21 14.3 22.3 13 24 13C25.7 13 27 14.3 27 16C27 17.7 25.7 19 24 19ZM24 15C23.4 15 23 15.4 23 16C23 16.6 23.4 17 24 17C24.6 17 25 16.6 25 16C25 15.4 24.6 15 24 15Z",
    fill: "#9C82FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27H21V25H23.6L13.3 14.7C12.9 14.3 12.9 13.7 13.3 13.3C13.5 13.1 13.7 13 14 13C14.3 13 14.5 13.1 14.7 13.3L25 23.6V21H27V26C27 26.6 26.6 27 26 27Z",
    fill: "#9C82FA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsApr);
export default __webpack_public_path__ + "static/media/ps-apr.47f7895fefc142f56a58845b9398b7e6.svg";
export { ForwardRef as ReactComponent };